<template>
  <el-container class="home-container">
    <el-header>
      <div class="header-left">
        <img :src="logoUrl" alt="欧小橙" class="header-logo" />
        <h3>欧小橙代拍管理平台</h3>
      </div>
      <div class="header-right">
        <span>欢迎, {{ userInfo.nickname || userInfo.username }}</span>
        <el-button type="text" class="self-edit-btn" @click="handleEditSelf">修改我的信息</el-button>
        <el-button type="text" @click="handleLogout">退出</el-button>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="activeMenu" :router="true">
          <!-- 无子节点时用 el-menu-item 才能走 router 跳转；全部用 submenu 时标题点击只会展开/收起 -->
          <template v-for="menu in sidebarMenus">
            <el-submenu
              v-if="menu.children && menu.children.length"
              :key="'sub-' + menu.id"
              :index="'sub-' + menu.id"
            >
              <template slot="title">
                <i :class="menu.icon || 'el-icon-menu'"></i>
                <span>{{ menu.name }}</span>
              </template>
              <template v-for="child in menu.children">
                <el-submenu
                  v-if="child.children && child.children.length"
                  :key="'sub2-' + child.id"
                  :index="'sub2-' + child.id"
                >
                  <template slot="title">
                    <i :class="child.icon || 'el-icon-menu'"></i>
                    <span>{{ child.name }}</span>
                  </template>
                  <el-menu-item
                    v-for="grandson in child.children"
                    :key="grandson.id"
                    :index="menuRoutePath(grandson.path)"
                  >
                    <i :class="grandson.icon || 'el-icon-menu'"></i>
                    <span>{{ grandson.name }}</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item
                  v-else
                  :key="'item-' + child.id"
                  :index="menuRoutePath(child.path)"
                >
                  <i :class="child.icon || 'el-icon-menu'"></i>
                  <span>{{ child.name }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
              v-else-if="menu.path !== undefined && menu.path !== null && menuRoutePath(menu.path)"
              :key="'item-' + menu.id"
              :index="menuRoutePath(menu.path)"
            >
              <i :class="menu.icon || 'el-icon-menu'"></i>
              <span>{{ menu.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>

    <!-- 修改当前用户信息对话框 -->
    <el-dialog title="修改我的信息" :visible.sync="selfDialogVisible" width="450px" @close="selfDialogVisible = false">
      <el-form :model="selfForm" label-width="80px">
        <el-form-item label="用户名">
          <span>{{ userInfo.username }}</span>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="selfForm.nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="selfForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="selfForm.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="0">未知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="selfForm.password" type="password" placeholder="留空表示不修改密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="selfDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSelfSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { logout, getMenus, updateUser } from '@/api'

export default {
  name: 'Home',
  data() {
    return {
      logoUrl: require('@/static/logo.png'),
      sidebarMenus: [],
      selfDialogVisible: false,
      selfForm: {
        nickname: '',
        phone: '',
        gender: 0,
        password: ''
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    activeMenu() {
      // 数据库存的是相对路径 user，与 el-menu-item index 和 $route.path 直接对齐
      return this.$route.path
    }
  },
  async created() {
    await this.loadMenus()
  },
  methods: {
    /**
     * 侧栏 el-menu 开启 router 时，index 会交给 vue-router。
     * 若库里写成 coupon 而无前导 /，会变成相对路径（例如在 /menu 下点到 /menu/coupon），与注册路由不一致 → 空白页。
     */
    menuRoutePath(path) {
      if (path === undefined || path === null) return ''
      const s = String(path).trim()
      if (!s) return ''
      return s.startsWith('/') ? s : '/' + s
    },

    async loadMenus() {
      try {
        const res = await getMenus()
        this.sidebarMenus = res.data || []
      } catch (e) {
        console.error('加载菜单失败', e)
        this.sidebarMenus = []
      }
    },

    async handleLogout() {
      try {
        await logout()
      } catch (error) {
        console.error(error)
      }
      this.$store.dispatch('logout')
      this.$message.success('已退出登录')
      this.$router.push('/login')
    },

    handleEditSelf() {
      const info = this.userInfo
      this.selfForm = {
        nickname: info.nickname || '',
        phone: info.phone || '',
        gender: info.gender || 0,
        password: ''
      }
      this.selfDialogVisible = true
    },

    async handleSelfSubmit() {
      try {
        const data = {
          id: this.userInfo.id,
          username: this.userInfo.username,
          nickname: this.selfForm.nickname,
          phone: this.selfForm.phone,
          gender: this.selfForm.gender
        }
        if (this.selfForm.password) {
          data.password = this.selfForm.password
        }
        await updateUser(data)
        const updated = { ...this.userInfo, ...data }
        this.$store.commit('SET_USER_INFO', updated)
        this.$message.success('修改成功')
        this.selfDialogVisible = false
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #FF8C00;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.header-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}
.header-left h3 {
  margin: 0;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}
.header-right .el-button {
  color: white;
}
.self-edit-btn {
  background: rgba(255, 255, 255, 0.18) !important;
  border: 1px solid rgba(255, 255, 255, 0.35) !important;
  border-radius: 6px;
  padding: 6px 12px;
  font-weight: 600;
}
.self-edit-btn:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.55) !important;
}
.el-aside {
  background-color: #F2F6FC;
}
</style>
